import React from 'react';

import { AdaptiveSingleLineText, Icons, Tooltip } from '@components/common';

import { useDownloadFile } from '@hooks/common/useDownloadFile';

import { convertBytesToSize } from '@utils/fileSizeFormatter';

import { IAssetFile } from '@interfaces/assets/asset';

import { fileExtensions } from '@constants/common';

import styles from './FilesList.module.scss';

const ICON_SIZE = '20';

interface IFileProps {
	file: IAssetFile;
	handleRemoveFile?: (fileId: string) => void;
	maxWidth: number;
	isViewMode: boolean;
	isDeleteInViewMode: boolean;
}

const File = ({
	file,
	handleRemoveFile,
	maxWidth,
	isViewMode,
	isDeleteInViewMode,
}: IFileProps) => {
	const { downloadFile } = useDownloadFile();

	const onClickDownload = () => downloadFile(file.id as any);

	const extension = file?.type?.title || (fileExtensions[file?.mimeType] || '');
	const convertedSize = file?.size ? convertBytesToSize(file.size) : '';

	const removeFile = () => handleRemoveFile && handleRemoveFile(file.id);

	return (
		<div className={styles.document}>
			<div className={styles.icon}>
				{Icons.fileIcon()}
			</div>
			<div className={styles.body}>
				<div className={styles.filename}>
					<div className={styles.name}>
						<AdaptiveSingleLineText
							className={styles.padding}
							maxWidth={maxWidth}
							paddingsSize={0}
							text={file.name}
						/>
					</div>
					{!isViewMode
						&& <div
							className={styles.deleteIcon}
							onClick={removeFile}
						>
							{Icons.removeIcon()}
						</div>
					}
				</div>
				<div className={styles.description}>
					<div className={styles.extension}>
						{extension.toUpperCase()}
					</div>
					<div className={styles.size}>
						{convertedSize}
					</div>
				</div>
			</div>
			{isViewMode
				&& <Tooltip
					content='Download'
					maxWidth={maxWidth}
				>
					<span
						className={styles.downloadIcon}
						onClick={onClickDownload}
					>
						{Icons.export({ height: ICON_SIZE, width: ICON_SIZE })}
					</span>
				</Tooltip>
			}
			{isViewMode && isDeleteInViewMode
				&& <Tooltip
					content='Delete'
					maxWidth={maxWidth}
				>
					<span
						className={styles.downloadIcon}
						onClick={removeFile}
					>
						{Icons.deleteCustomColor({ height: ICON_SIZE, width: ICON_SIZE })}
					</span>
				</Tooltip>
			}
		</div>
	);
};

export default File;
